import moment from 'moment';
import { formatDateDB } from '@fortress-technology-solutions/fortress-component-library/utils';

const toDateStringUtc = (value) => {
  if (!value) return null;
  const m = moment.utc(value).startOf('day');
  return m.isValid() ? formatDateDB(m) : null;
};

const mergeIntervals = (rawIntervals = []) => {
  const intervals = rawIntervals
    .filter((d) => d?.[0])
    .map(([start, end]) => [
      toDateStringUtc(start),
      end == null ? null : toDateStringUtc(end),
    ])
    .filter(([start]) => Boolean(start))
    .sort((a, b) => a[0].localeCompare(b[0]));

  const merged = [];
  for (const [start, end] of intervals) {
    if (!merged.length) {
      merged.push([start, end]);
      continue;
    }

    const last = merged[merged.length - 1];
    const lastEnd = last[1];

    if (lastEnd == null) continue; // already blocked indefinitely

    const lastEndPlusOne = toDateStringUtc(moment.utc(lastEnd).add(1, 'day'));

    if (start <= lastEndPlusOne) {
      if (end == null) {
        last[1] = null;
      } else if (end > lastEnd) {
        last[1] = end;
      }
    } else {
      merged.push([start, end]);
    }
  }

  return merged;
};

export const hasAnyAvailableStartDateFromToday = ({
  unavailableDates = [],
  actualOrAnticipatedMoveOutDate,
  now = moment.utc(),
}) => {
  const todayString = toDateStringUtc(now);
  const maxAllowedString = actualOrAnticipatedMoveOutDate?.length
    ? toDateStringUtc(actualOrAnticipatedMoveOutDate)
    : null;

  if (!todayString) return true;
  if (maxAllowedString && todayString > maxAllowedString) return false;

  const merged = mergeIntervals(unavailableDates);
  let cursor = todayString;

  for (const [start, end] of merged) {
    if (start > cursor) {
      return !maxAllowedString || cursor <= maxAllowedString;
    }

    // start <= cursor
    if (end == null) return false;

    if (cursor <= end) {
      cursor = toDateStringUtc(moment.utc(end).add(1, 'day'));
      if (maxAllowedString && cursor > maxAllowedString) return false;
    }
  }

  return !maxAllowedString || cursor <= maxAllowedString;
};
